module.exports = __webpack_public_path__ + "img/border_long_radio.d675dc74.svg";